import {FC} from 'react'

export const FullPageFallback: FC = () => null
